import { isEmpty } from 'lodash-es';
import { TechFetchSearch } from 'wisestep-api';
import { IFilterList } from 'wisestep-base';

export const pushSearchFilters = (data: TechFetchSearch) => {
  const filtersArray: IFilterList[] = [];
  if (!isEmpty(data.allAny))
    filtersArray.push({
      tag: `Search Pattern: ${data.allAny}`,
      id: 'allAny',
    });
  if (!isEmpty(data.willingToRelocate))
    filtersArray.push({
      tag: `Relocation: ${data.willingToRelocate}`,
      id: 'willingToRelocate',
    });
  if (!isEmpty(data.workAuthorizations))
    filtersArray.push({
      tag: `Work Auth.: ${data.workAuthorizations?.join(',')}`,
      id: 'workAuthorizations',
    });
  if (!isEmpty(data.experiences))
    filtersArray.push({
      tag: `Experience: ${data.experiences?.join(',')}`,
      id: 'experiences',
    });
  if (!isEmpty(data.degrees))
    filtersArray.push({
      tag: `Degrees: ${data.degrees?.join(',')}`,
      id: 'degrees',
    });
  if (!isEmpty(data.preferredEmploymentTypes))
    filtersArray.push({
      tag: `Emp. Type: ${data.preferredEmploymentTypes?.join(',')}`,
      id: 'preferredEmploymentTypes',
    });
  if (!isEmpty(data.usExperiences))
    filtersArray.push({
      tag: `US Exp.: ${data.usExperiences?.join(',')}`,
      id: 'usExperiences',
    });
  if (!isEmpty(data.domainExposures))
    filtersArray.push({
      tag: `Domain Exp.: ${data.domainExposures?.join(',')}`,
      id: 'domainExposures',
    });

  return filtersArray;
};
